<template>
  <div class="login">
    <!-- 0819修改：新增暗色切换按钮 -->
    <button class="themetoggle" :title="isDark ? '切换到浅色模式' : '切换到暗色模式'" @click="toggleTheme">
      <svg v-if="isDark" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
      <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>
    </button>
    <div class="userform">
      <div class="logoform">
        <div class="alogo"></div>
        <div class="content">OA系统</div>
      </div>
      <el-form class="loginform" :model="user" status-icon :rules="rules" ref="ruleForm">
        <el-form-item prop="nickname">
          <el-input v-model.number="user.nickname" prefix-icon="el-icon-user" :clearable="true" class="inputline"
            maxlength="40" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input type="password" v-model="user.pwd" autocomplete="off" prefix-icon="el-icon-lock" :clearable="true"
            :show-password="true" class="inputline" maxlength="20" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        nickname: '',
        pwd: '',
      },
      isDark: document.documentElement.classList.contains('dark'), /* 0819修改 */
      rules: {
        nickname: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 40, message: '长度在 3 到 40 个字符', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    // userTest().then(res => {
    //   console.log(res)
    // })
  },
  methods: {
    // 0819修改：新增主题切换方法
    toggleTheme() {
      const root = document.documentElement
      root.classList.toggle('dark')
      this.isDark = root.classList.contains('dark')
      localStorage.setItem('oa-theme', this.isDark ? 'dark' : 'light')
      window.dispatchEvent(new Event('theme-change')) // 0819修改：通知表格重新布局
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login()
        } else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    login() {
      this.$store
        .dispatch("user/login", { nickname: this.user.nickname, pwd: this.user.pwd })
        .then(() => {
          // this.$store.dispatch('user/account')
          this.$router.push({
            path: this.$route.query.redirect || "/home"
          });
        })
        .catch(error => {
          console.warn(error);
        });
    }
  }
}
</script>

<style lang="scss">
.login {
  @extend %center;
  height: 100vh;
  background: var(--login-bg); /* 0819修改 */
}

/* 0819修改：新增切换按钮样式 */
.themetoggle {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: var(--card);
  color: var(--text-1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  box-shadow: var(--shadow);
  transition: border-color 0.2s, color 0.2s;
  z-index: 10;
}

.themetoggle:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.userform {
  width: rem(700);
  // height: rem(700);
  padding: 0;
  // padding: rem(300) 0 0 0;
  box-sizing: border-box;
  background: var(--card); /* 0819修改 */
  // background: url(../assets/login.png) no-repeat 0 0 #fff;
  box-shadow: var(--shadow); /* 0819修改 */
  border-radius: rem(16);
  @extend %center;

  .logoform {
    width: 100%;
    height: 240px;
    margin-bottom: 40px;
    border-radius: 20px 20px 0 0;
    background: $c;
    color: #fff;

    .alogo {
      width: 514px;
      height: 58px;
      display: block;
      margin: 60px auto 50px;
      background: url(../assets/alogo.png) no-repeat;
      background-size: contain;
    }

    .content {
      font-size: 28px;
    }
  }

  .loginform {
    width: 400px;

    .el-form-item__content {
      margin-bottom: 40px;
    }

    .inputline {
      input {
        border: 0 solid transparent;
        border-bottom: 1px solid var(--border); /* 0819修改 */
        border-radius: 0;
        font-size: 20px;
      }

      .el-input__prefix {
        font-size: 28px;
        color: var(--text-2); /* 0819修改 */
        transform: translate(-8px, -6px);
      }
    }

    .el-button {
      width: 400px;
      height: 50px;
      padding: 0;
      font: 24px/48px $font;
    }
  }
}
</style>